module.exports = __webpack_public_path__ + "static/AL_training_gif1_opti-d7d8f12bce9b3c95c0e62e5acaf4a2da.gif";